import { timeslotsStore } from 'entities/timeslots/store/store';
import { observer } from 'mobx-react-lite';
import { FC, memo, useCallback, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { Timeslot } from './timeslot';
import { DoctorTimeslotMap, TimeslotsByDoctorProps } from './types';
import { ITimeslot } from 'entities/timeslots/store/types';
import { clinicsStore } from 'entities/clinics';
import geoIcon from 'assets/iconfinder_geo.svg';
import { BELOW_SLOT_NOTES_TEXT } from 'shared/consts';

const arePropsEqual = (
	prevProps: {
		slot: ITimeslot;
		selectedSlot: ITimeslot | null;
		selectSlot: (timeslot: ITimeslot) => void;
	},
	nextProps: {
		slot: ITimeslot;
		selectedSlot: ITimeslot | null;
		selectSlot: (timeslot: ITimeslot) => void;
	},
) => {
	return (
		prevProps.slot === nextProps.slot &&
		prevProps.slot.id === nextProps.slot.id &&
		prevProps.selectSlot === nextProps.selectSlot
	);
};

const MemoizedTimeslot = memo(Timeslot, arePropsEqual);

export const TimeslotsByDoctor: FC<TimeslotsByDoctorProps> = observer(
	({ doctorId, selectedSlot, selectDoctorSlot }) => {
		const [doctorTimeslots, setDoctorTimeslots] =
			useState<DoctorTimeslotMap | null>(null);

		useEffect(() => {
      if (doctorId) {
        const slots = timeslotsStore.doctorsSlots.get(doctorId) || [];
				if (slots) {
					setDoctorTimeslots(slots as unknown as DoctorTimeslotMap);
				}
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [timeslotsStore.doctorsSlots.size, doctorId]);

		const selectSlot = useCallback(
			(timeslot: ITimeslot) => () => {
				selectDoctorSlot(timeslot);
			},
			[selectDoctorSlot],
		);

		return (
			<div className={styles['timeslots']}>
				{doctorTimeslots &&
					Array.from(doctorTimeslots.entries()).map(
						([branch, slots]) => (
							<div
								key={branch}
								className={styles['timeslots__item']}
							>
								<div className={styles['timeslots__branch']}>
									<img
										className={
											styles['timeslots__branch-image']
										}
										src={geoIcon}
									/>
									<p
										className={
											styles['timeslots__branch-text']
										}
									>
										{
											clinicsStore.clinicsMap.get(branch)
												?.name
										}
									</p>
								</div>
								<div className={styles['timeslots__list']}>
									{slots.map(slot => (
										<MemoizedTimeslot
											key={slot.id}
											slot={slot}
											selectedSlot={selectedSlot}
											selectSlot={selectSlot(slot)}
										/>
									))}
								</div>
							</div>
						),
					)}
          {BELOW_SLOT_NOTES_TEXT && <p className={styles['timeslots__belowtext']} dangerouslySetInnerHTML={{__html: BELOW_SLOT_NOTES_TEXT}}></p>}
			</div>
		);
	},
);
